import { ISelector } from '@omaze/redux';

import { createFeatureFlagSelector } from '../../FeatureFlag.factory';
import { IFeatureFlagState } from '../../FeatureFlag.state';

export const selectFlag: ISelector<
IFeatureFlagState,
boolean
> = createFeatureFlagSelector(
    (state: IFeatureFlagState, flag: string): boolean => {
        return state.flags[flag];
    },
);
